export default __webpack_public_path__ + "static/media/main_section21.4161a129.jpg";